import CryptoJS from "crypto-js"
import encryptKey from './encryptKey'

function randomKey(num){
  let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'r', 's', 't', 'w', 'x', 'y', 'z']
  let str = ''
  for(let i=0;i<num;i++){
    let id = Math.ceil(Math.random()*50)
    str += arr[id]
  }
  return str
}

function aesEncrypt(data, key){
  // var iv = CryptoJS.lib.WordArray.random(16)
  let random = encryptKey.iv//randomKey(16)
  var iv = CryptoJS.enc.Utf8.parse(random)
  var encrypted = CryptoJS.AES.encrypt(data, key, {
    iv:iv,
    mode : CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64) //+ ':' +random
}

function aesDecrypt(data, key){
  // var parts = data.split(':')
  // var ciphertext = CryptoJS.enc.Base64.parse(parts[0])
  // var iv = CryptoJS.enc.Utf8.parse(parts[1])
  var iv = CryptoJS.enc.Utf8.parse(encryptKey.iv)
  var decrypted = CryptoJS.AES.decrypt({ciphertext:data}, key, {
    iv:iv,
    mode : CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export {
  randomKey,
  aesEncrypt,
  aesDecrypt
}


// WEBPACK FOOTER //
// ./src/assets/js/Aes.js